export default __webpack_public_path__ + "static/media/calendar-icon-gray-.e6d6627e.svg";